let comUrl = ''
let cpOrderUrl = ''
// 公司前缀
const prefix = 'mr'
const payOtherPageUrl = 'https://newlinkgames.com/payOtherPage/' // /policy /refund /terms



const originConfig: any = {
    'https://checkout.newlinkgames.com': {
        name: 'new link games',
        logo: {
            top: require('@/assets/img/checkout.newlinkgames.com/logo/top.png'),
            bottom: require('@/assets/img/checkout.newlinkgames.com/logo/bottom.png'),
            modal: require('@/assets/img/checkout.newlinkgames.com/logo/modal.png'),
            login: require('@/assets/img/checkout.newlinkgames.com/logo/login.png'),
        }
    },
    'https://checkout.livenplay.net': {
        name: 'liven play games',
        logoList: {
            // top: require('@/assets/img/checkout.newlinkgames.com/logo/top.png'),
            // bottom: require('@/assets/img/checkout.newlinkgames.com/logo/bottom.png'),
            // modal: require('@/assets/img/checkout.newlinkgames.com/logo/modal.png'),
            // login: require('@/assets/img/checkout.newlinkgames.com/logo/login.png'),
        }
    }
}
const originObj = originConfig[window.location.origin] || originConfig['https://checkout.newlinkgames.com']


// const {
//     protocol
// } = window.location
switch (process.env.NODE_ENV) {
    case 'production': //线上环境
        comUrl = `https://api.newlinkgames.com` //请求域名
        cpOrderUrl = 'https://xhyhw-xy.xinliugame.net'

        break;
    case 'test': //测试环境
        comUrl = `https://api-dev.newlinkgames.com`
        cpOrderUrl = 'https://xhyhw-xy.xinliugame.net'
        break;
    default: //本地开发环境
        comUrl = '/replaceUrl'
        cpOrderUrl = '/cpOrderUrl'
        // imgUrl = ''
        break;
}
// console.log(process.env.NODE_ENV, '===========process.env.NODE_ENV');

export {
    comUrl,  //请求域名
    cpOrderUrl, //CP订单域名
    payOtherPageUrl, //服务协议 隐私政策 退款政策 域名
    prefix, //公司前缀
    originObj
}
